/* IEMs.bg — Header search bar: open/close + predictive product suggestions */
(function () {
  'use strict';

  const panel = document.querySelector('[data-search-panel]');
  if (!panel) return;

  const toggles  = document.querySelectorAll('[data-search-toggle]');
  const form     = panel.querySelector('form');
  const input    = panel.querySelector('[data-search-input]');
  const results  = panel.querySelector('[data-search-results]');
  const closeBtn = panel.querySelector('[data-search-close]');
  const predictiveUrl = panel.dataset.predictiveUrl || '/search/suggest';

  const MIN_CHARS  = 2;
  const DEBOUNCE   = 250;
  const SUGGESTIONS = 6;

  let debounceTimer;
  let controller;

  /* ── Panel ── */
  function isOpen() { return panel.classList.contains('is-open'); }

  function open() {
    panel.classList.add('is-open');
    toggles.forEach(t => t.setAttribute('aria-expanded', 'true'));
    input.focus();
    input.select();
    const q = input.value.trim();
    if (q.length >= MIN_CHARS) suggest(q);
  }

  function close() {
    panel.classList.remove('is-open');
    toggles.forEach(t => t.setAttribute('aria-expanded', 'false'));
    hideResults();
  }

  function hideResults() {
    controller?.abort();
    clearTimeout(debounceTimer);
    results.hidden = true;
    results.innerHTML = '';
    input.setAttribute('aria-expanded', 'false');
  }

  toggles.forEach(t => t.addEventListener('click', () => (isOpen() ? close() : open())));
  closeBtn?.addEventListener('click', () => {
    close();
    toggles[0]?.focus();
  });

  /* ── Suggestions ── */
  async function suggest(query) {
    controller?.abort();
    controller = new AbortController();

    const url = predictiveUrl +
      '?q=' + encodeURIComponent(query) +
      '&resources[type]=product' +
      '&resources[limit]=' + SUGGESTIONS +
      '&section_id=predictive-search';

    try {
      const res = await fetch(url, { signal: controller.signal });
      if (!res.ok) throw new Error('Predictive search failed: ' + res.status);
      const html = await res.text();
      results.innerHTML = html;
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    } catch (err) {
      if (err.name === 'AbortError') return;
      /* Suggestions are a nicety — the form still submits to /search on failure. */
      console.error(err);
      hideResults();
    }
  }

  input.addEventListener('input', () => {
    const q = input.value.trim();
    clearTimeout(debounceTimer);
    if (q.length < MIN_CHARS) {
      hideResults();
      return;
    }
    debounceTimer = setTimeout(() => suggest(q), DEBOUNCE);
  });

  /* Don't submit an empty query — /search?q= renders a bare results page. */
  form.addEventListener('submit', e => {
    if (!input.value.trim()) {
      e.preventDefault();
      input.focus();
    }
  });

  /* ── Keyboard ── */
  function items() {
    return Array.from(results.querySelectorAll('[data-search-result]'));
  }

  function move(step) {
    const list = items();
    if (list.length === 0) return;

    const current = list.indexOf(document.activeElement);
    if (current === -1) {
      /* Focus is still in the input — step into the list from either end. */
      list[step > 0 ? 0 : list.length - 1].focus();
      return;
    }

    const next = current + step;
    if (next < 0) {
      input.focus();
      return;
    }
    list[Math.min(next, list.length - 1)].focus();
  }

  panel.addEventListener('keydown', e => {
    if (e.key === 'Escape') {
      close();
      toggles[0]?.focus();
      return;
    }
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      move(1);
    }
    if (e.key === 'ArrowUp') {
      e.preventDefault();
      move(-1);
    }
  });

  /* ── Dismiss on outside click ── */
  document.addEventListener('click', e => {
    if (!isOpen()) return;
    if (panel.contains(e.target) || e.target.closest('[data-search-toggle]')) return;
    close();
  });
})();
